<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->

    <OpenGallery v-if="this.$store.state.opengallery !== 0">  </OpenGallery>

    <Navigation> </Navigation>

    <VereinNav class="hidden md:block"> </VereinNav>

    <Meldungen> </Meldungen>

    <VereinAbout v-if="this.$route.params.url == undefined"> </VereinAbout>

    <News v-if="this.$route.params.url == 'news'"> </News>

    <Galleries v-if="this.$route.params.url == 'galerie'"> </Galleries>

    <Kontakt v-if="this.$route.params.url == 'kontakt'"> </Kontakt>

    <VereinMitglied v-if="this.$route.params.url == 'mitglied'"> </VereinMitglied>

    <Cookie> </Cookie>

    <FooterVue> </FooterVue>


  </div>


</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import VereinAbout from '@/components/VereinAbout.vue'
import VereinNav from '@/components/VereinNav.vue'
import News from '@/components/News.vue'
import Galleries from '@/components/Galleries.vue'
import FooterVue from '@/components/FooterVue.vue'
import Meldungen from '@/components/Meldungen.vue'
import OpenGallery from '@/components/OpenGallery.vue'
import Kontakt from '@/components/Kontakt.vue'
import VereinMitglied from '@/components/VereinMitglied.vue'
import Cookie from '@/components/Cookie.vue'

export default {
  name: 'verein',

  components: {
    Navigation,
    VereinAbout,
    VereinNav,
    News,
    Galleries,
    FooterVue,
    Meldungen,
    OpenGallery,
    Kontakt,
    VereinMitglied,
    Cookie

  },

  methods: {

    onload: function () {
      this.$store.dispatch('initialfetch');
    },

    matchHeight() {

      // setInterval(function(){
      //
      //   let insideheight = this.$refs.wandern.clientHeight;
      //
      //   this.$store.commit('updateheight', insideheight);
      //
      // }.bind(this), 500);

    }

  },
  mounted: function(){

    this.onload();
    // this.matchHeight();

  },

  computed: {

  }

}
</script>

<style media="screen">

</style>
